export const CHART_COLORS = ["#0D9488", "#0284C7", "#D97706", "#7C3AED", "#E11D48", "#059669", "#0B192C", "#64748B"];
export const TOOLTIP_STYLE = { borderRadius: 12, border: "1px solid #E2E8F0", fontSize: 13 };

export default function ChartCard({ title, subtitle, children, testid, empty, className = "" }) {
  return (
    <div className={`bg-white border border-slate-200/80 rounded-xl shadow-sm p-5 ${className}`} data-testid={testid}>
      <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
      {subtitle && <p className="text-sm text-slate-500">{subtitle}</p>}
      <div className="mt-4">
        {empty ? <div className="h-56 grid place-items-center text-sm text-slate-400" data-testid={`${testid}-empty`}>{empty}</div> : children}
      </div>
    </div>
  );
}
